/** Totales de pedido en /account/ — solo items − pagado */

export function calcOrderItemsTotal(items = []) {
  if (!Array.isArray(items)) return 0
  return items.reduce((acc, item) => {
    if (item?.marketPriceCP === '' || item?.marketPriceCP == null) return acc
    return acc + parseFloat(item.marketPriceCP) * (item.quantity || 1)
  }, 0)
}

export function calcOrderTotal(order) {
  return calcOrderItemsTotal(order?.items)
}

export function calcOrderPaid(order) {
  const paid = parseFloat(order?.paidValue)
  return Number.isFinite(paid) ? paid : 0
}

export function calcOrderBalance(order) {
  return calcOrderTotal(order) - calcOrderPaid(order)
}

export function getOrderRowAmounts(order) {
  const total = calcOrderTotal(order)
  const paid = calcOrderPaid(order)
  return {
    total,
    paidValue: paid,
    balance: total - paid,
  }
}

export function sumOrdersTotals(orders = []) {
  return orders.reduce(
    (acc, order) => ({
      total: acc.total + calcOrderTotal(order),
      paid: acc.paid + calcOrderPaid(order),
      balance: acc.balance + calcOrderBalance(order),
    }),
    { total: 0, paid: 0, balance: 0 },
  )
}

export function dedupeOrdersById(orders = []) {
  const seen = new Set()
  return orders.reduce((acc, order) => {
    if (!order) return acc
    const key = order._id || order.id
    if (!key || seen.has(String(key))) return acc
    seen.add(String(key))
    acc.push(order)
    return acc
  }, [])
}
